import React from "react";
import RowList from "../components/Main/RowList";
import ButtonTextCard from "../components/Main/ButtonTextCard";
import ImageCallout from "../components/Main/ImageCallout";
import CtaBanner from "../components/Main/CtaBanner";
import Page from "../components/Page";

export default function Volunteer(props) {
  const {
    //Hero Section fields
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId,
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,

    //Volunteer
    volunteer_columns: volunteerColumns, //repeater
    volunteer_heading: volunteerHeading,
    volunteer_intro: volunteerIntro,
    volunteer_link: {
      title: volunteerTitle,
      url: volunteerUrl,
      target: volunteerTarget,
    },

    // callout_upper_images: calloutImages,
    callout_upper_images: calloutImages,
    callout_upper_heading: calloutHeading,
    callout_upper_sub_heading: calloutSubheading,
    callout_upper_paragraph: calloutParagraph,
    callout_upper_link: { url: calloutUrl, title: calloutLinkTitle },
    callout_upper_sub_text: calloutSubText,
    callout_upper_column_order: colOrder,

    //callout_about_image:
    callout_about_image: { url: aboutImageUrl },
    callout_about_image_caption: aboutCaption,
    callout_about_heading: aboutHeading,
    callout_about_sub_heading: aboutSubheading,
    callout_about_paragraph: aboutParagraph,
    callout_about_link: { url: aboutUrl, title: aboutLinkTitle },
    callout_about_column_order: aboutColOrder,
    intro_link_icon: aboutIcon,

    //callout_lower_image:
    //callout_lower_image: {url: lowerImageUrl},
    callout_lower_image_caption: lowerCaption,
    callout_lower_heading: lowerHeading,
    callout_lower_sub_heading: lowerSubheading,
    callout_lower_paragraph: lowerParagraph,
    //callout_lower_link: {url: lowerUrl, title: lowerLinkTitle},
    callout_lower_column_order: lowerColOrder,
    intro_link_icon: lowerIcon,

    //CtaBanner Fields
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton },
  } = props.acf;

  return (
    <React.Fragment>
      <Page
        title={introHeading}
        body={introParagraph}
        bgImage={introImage}
        bgId={imageId}
        alt={alt}
        height={height}
        width={width}
        slug={"/get-involved"}
      >
        <main id="content">
          <a id="skip" className="skip"></a>
          <div className="container-fluid involved-volunteer tw-pt-40">
            <RowList partners title={volunteerHeading} body={volunteerIntro} />
            <ButtonTextCard
              volunteer
              content={volunteerColumns}
              button={volunteerTitle}
              link={volunteerUrl}
              target={volunteerTarget}
            />
          </div>
          <ImageCallout
            array
            reversed
            title={calloutHeading}
            body={calloutParagraph}
            link={calloutUrl}
            button={calloutLinkTitle}
            images={calloutImages}
          />
          <ImageCallout
            noSlug
            title={aboutHeading}
            body={aboutParagraph}
            link={aboutUrl}
            button={aboutLinkTitle}
            image={aboutImageUrl}
          />
        </main>

        <CtaBanner
          noSlug
          title={ctaHeading}
          link={ctaLink}
          button={ctaButton}
        />
      </Page>
      <style jsx>
        {`
          .involved-volunteer {
            margin-bottom: 100px;
          }
        `}
      </style>
    </React.Fragment>
  );
}
